<template>
	<v-menu
		:value="value"
		:position-absolutely="true"
		:position-x="positionX"
		:position-y="positionY"
		:nudge-top="0"
		content-class="booking-menu-actions"
		@input="sendValue"
		:v-bind="$attrs"
	>
		<v-list>
			<v-list-tile
				v-for="(item, indexItem) in menuList"
				:key="indexItem"
				@click="makeAnAction(item)"
			>
				<v-list-tile-action>
					<v-icon
						v-if="item.icon"
						:class="[
						'icon-style',
						item.icon === 'cancel' ? 'red--text' : null]"
					>{{item.icon}}</v-icon>
					<img v-else :src="item.image" alt="">
				</v-list-tile-action>
				<v-list-tile-title>{{item.title}}</v-list-tile-title>
			</v-list-tile>
		</v-list>
	</v-menu>
</template>
<script>
import { format } from 'date-fns';
import helper from '@/shared/helper';
import lib from '@/shared/lib';

const helperMethods = helper.methods;
const { setNewProperty } = lib;

function sendValue(value) {
	this.$emit('input', value);
}

function makeAnAction(action) {
	const { code } = action;
	const options = {
		seeBooking: this.visualizeAction.bind(null),
		edit: this.editBook.bind(null, this.reservation, action),
		checkin: this.checkInFn.bind(null, this.reservation, action),
		checkout: this.checkInFn.bind(null, this.reservation, action, code),
		noShow: this.noShowFn.bind(null),
		cancelBooking: this.cancelBooking.bind(null),
		card: this.downloadCardTravel.bind(null, this.reservation),
		billing: this.checkInFn.bind(null, this.reservation, action, code),
		advance: this.goToPrepayment.bind(null, this.reservation, action),
		customer: this.checkInFn.bind(null, this.reservation, action, code),
		roomChange: this.editBook.bind(null, this.reservation, action),
	};
	options[code].call();
}

function goToPrepayment({ code }, { name }) {
	this.$router.push({
		name,
		params: {
			bookingCode: code,
		},
	});
}

async function downloadCardTravel(reservation) {
	const baseUrl = process.env.PMS_URL;
	const code = reservation.code;
	const typeDocumentCode = 'registerCard';
	const name = `TARJETA-DE-EMBARQUE${code}`;
	const responseType = 'blob';
	const cardModel = { details: [{}] };
	const response = await this.$http.post(`${baseUrl}/booking/${code}/report/${typeDocumentCode}`,
		cardModel, { responseType });
	const blob = helperMethods.generateBlob(response.bodyBlob);
	helperMethods.showDownloadDialog(blob, name, 'pdf');
}

function cancelBooking() {
	this.$emit('open-cancel-modal');
}

function openNoShowBooking() {
	this.$emit('no-show');
}

function checkInFn(reservation, action, code) {
	const { name } = action;
	const roomTypeId = reservation.entityId;
	let query = {
		initDate: format(reservation.bookingStart, 'YYYY-MM-DD'),
		endDate: format(reservation.bookingEnd, 'YYYY-MM-DD'),
		roomId: reservation.room.data.id,
		bookingCode: reservation.code,
	};
	const options = {
		checkout: this.setPropsToQuery.bind(null, query, ['active', 'tab-2']),
		billing: this.setPropsToQuery.bind(null, query, ['active', 'tab-6'], ['code', `${code}`]),
		customer: this.setPropsToQuery.bind(null, query, ['active', 'tab-1'], ['code', 'billing']),
	};
	query = options[code] ? options[code].call() : query;
	this.$router.push({
		name,
		params: {
			hotelId: this.subsidiaryId,
			roomTypeId,
		},
		query,
	});
}

function setPropsToQuery(que, ...args) {
	let newQue = { ...que };
	args.forEach((dupla) => {
		const [prop, value] = dupla;
		newQue = setNewProperty(prop, value)(newQue);
	});
	return newQue;
}

function noShowFn() {
	this.$emit('no-show');
}

function visualizeAction() {
	this.$emit('visualize-book');
}

function editBook(reservation, action) {
	const { name } = action;
	const params = {
		codeBooking: reservation.code,
	};
	this.$router.push({ name, params });
}

export default {
	name: 'menu-list',
	inheritAttrs: false,
	methods: {
		cancelBooking,
		checkInFn,
		downloadCardTravel,
		editBook,
		goToPrepayment,
		makeAnAction,
		noShowFn,
		openNoShowBooking,
		sendValue,
		setPropsToQuery,
		visualizeAction,
	},
	props: {
		menuList: {
			default: () => [],
			type: Array,
		},
		positionX: {
			default: 0,
			type: Number,
		},
		positionY: {
			default: 0,
			type: Number,
		},
		reservation: {
			default: () => {},
			type: Object,
		},
		subsidiaryId: {
			default: 0,
			type: [Number, String],
		},
		value: null,
	},
};
</script>




// WEBPACK FOOTER //
// MenuList.vue?399adfd8